export const portfolioData = {
    bathrooms: {
      title: "Bathrooms",
      subsections: [
        {
          id: "high-range",
          title: "High Range Bathrooms",
          description: "Premium bathroom installations featuring luxury fixtures and bespoke finishes.",
          note: "High-end projects are done with careful planning and refinement of detail. The services that we do include floor-to-ceiling tiling, mitered edges, shower niches, custom featured walls, herringbone tiling, wet rooms, and much more.",
          projects: [
            {
              id: "luxury-bathroom-design",
              title: "Luxury Bathroom Design and Installation",
              hasBeforeAfter: true,
              coverImage: "/images/luxury-bathroom/after_1_full_view.webp",
              images: [
                { src: "/images/luxury-bathroom/before_1_doorway.webp", caption: "Original bathroom view from doorway showing dated layout", type: "before" },
                { src: "/images/luxury-bathroom/before_2_vanity_mirror.webp", caption: "Original double vanity with mirrored cabinet and beige tiling", type: "before" },
                { src: "/images/luxury-bathroom/before_3_vanity_basin.webp", caption: "Original vanity area with standard basin and dated fixtures", type: "before" },
                { src: "/images/luxury-bathroom/before_4_shower.webp", caption: "Original shower enclosure with sliding glass door", type: "before" },
                { src: "/images/luxury-bathroom/before_5_bath_wc.webp", caption: "Original bathtub and WC area with beige tiling", type: "before" },
                { src: "/images/luxury-bathroom/after_1_full_view.webp", caption: "Full bathroom view with freestanding bath, rose gold fixtures and dark wood shower", type: "after" },
                { src: "/images/luxury-bathroom/after_2_mirror_vanity.webp", caption: "LED backlit organic-shaped mirror with double basin vanity and rose gold towel rail", type: "after" },
                { src: "/images/luxury-bathroom/after_3_freestanding_bath.webp", caption: "Freestanding bathtub with rose gold wall-mounted tap and LED niche shelf", type: "after" },
                { src: "/images/luxury-bathroom/after_4_vanity_oval_mirror.webp", caption: "Vanity area with oval LED mirror, white panelled cabinets and freestanding bath", type: "after" },
                { src: "/images/luxury-bathroom/after_5_shower_enclosure.webp", caption: "Walk-in shower enclosure with dark wood feature wall and rose gold fixtures", type: "after" },
                { src: "/images/luxury-bathroom/after_6_shower_detail.webp", caption: "Dark wood feature wall with rose gold rainfall shower, handheld shower and recessed niches", type: "after" },
                { src: "/images/luxury-bathroom/after_7_shower_enclosure_wc.webp", caption: "Walk-in shower with smoked glass door, rose gold frame and wall-hung WC", type: "after" },
                { src: "/images/luxury-bathroom/after_8_vanity_person.webp", caption: "Completed vanity area with organic LED mirror, heated towel rail and dark wood accents", type: "after" },
                { src: "/images/luxury-bathroom/after_9_led_niche_bath.webp", caption: "LED-lit niche shelf detail beside freestanding bathtub with rose gold tap", type: "after" },
                { src: "/images/luxury-bathroom/after_10_towel_rail_wc.webp", caption: "Rose gold heated towel rail with wall-hung Vitra toilet and marble-effect tiling", type: "after" }
              ]
            },
            {
              id: "jack-and-jill-conversion",
              title: "Full Bathroom Conversion to Jack & Jill Style",
              coverImage: "/images/jack-and-jill/jj_1_full_bathroom.webp",
              images: [
                { src: "/images/jack-and-jill/jj_1_full_bathroom.webp", caption: "Full bathroom view with grey vanity unit, heated towel rail and WC" },
                { src: "/images/jack-and-jill/jj_2_shower_wc_bath.webp", caption: "Quadrant shower enclosure with mosaic tile detail, WC and bath" },
                { src: "/images/jack-and-jill/jj_3_towel_rail_wc.webp", caption: "Chrome heated towel rail, wall-hung WC and shower enclosure" },
                { src: "/images/jack-and-jill/jj_4_door_shower_vanity.webp", caption: "Bathroom entrance with quadrant shower, vanity basin and mirror" },
                { src: "/images/jack-and-jill/jj_5_shower_mosaic.webp", caption: "Quadrant shower enclosure with mosaic tile feature and chrome fixtures" },
                { src: "/images/jack-and-jill/jj_6_shower_interior.webp", caption: "Inside the shower enclosure with mosaic tile band and chrome rainfall head" },
                { src: "/images/jack-and-jill/jj_7_vanity_closeup.webp", caption: "Grey vanity unit close-up with white basin and chrome taps" },
                { src: "/images/jack-and-jill/jj_8_towel_rail_wc_closeup.webp", caption: "Chrome heated towel rail and wall-hung WC close-up" },
                { src: "/images/jack-and-jill/jj_9_tile_corner_detail.webp", caption: "Precision tile corner detail with matching grout finish" }
              ]
            },
            {
              id: "ensuite-transformation",
              title: "Ensuite Transformation",
              hasBeforeAfter: true,
              coverImage: "/images/ensuite-transformation/after-4.jpg",
              images: [
                { src: "/images/ensuite-transformation/before-1.jpg", caption: "Original shower enclosure with dated tiles and glass screen", type: "before" },
                { src: "/images/ensuite-transformation/before-2.jpg", caption: "Original full ensuite with dated fixtures and laminate flooring", type: "before" },
                { src: "/images/ensuite-transformation/before-3.jpg", caption: "Original basin and window area with exposed pipes", type: "before" },
                { src: "/images/ensuite-transformation/before-4.jpg", caption: "Original ensuite doorway view with pedestal basin and radiator", type: "before" },
                { src: "/images/ensuite-transformation/after-1.jpg", caption: "New LED mirror cabinet and wall-mounted basin with black tap", type: "after" },
                { src: "/images/ensuite-transformation/after-2.jpg", caption: "Window area with modern basin, black radiator and grey tiling", type: "after" },
                { src: "/images/ensuite-transformation/after-3.jpg", caption: "Black rainfall shower head and riser rail with dark tile surround", type: "after" },
                { src: "/images/ensuite-transformation/after-4.jpg", caption: "Complete ensuite with black-framed shower, WC, basin and radiator", type: "after" },
                { src: "/images/ensuite-transformation/after-5.jpg", caption: "Floor tiling detail with quadrant shower enclosure and WC", type: "after" },
                { src: "/images/ensuite-transformation/after-6.jpg", caption: "Doorway view with panelled door, basin, mirror and shower enclosure", type: "after" }
              ]
            },
            {
              id: "downstairs-toilet-conversion",
              title: "Downstairs Toilet Conversion + Radiator",
              hasBeforeAfter: true,
              coverImage: "/images/downstairs-toilet/after-1.jpg",
              images: [
                { src: "/images/downstairs-toilet/before-1.jpg", caption: "Original downstairs toilet", type: "before" },
                { src: "/images/downstairs-toilet/after-1.jpg", caption: "Modern cloakroom with feature tiles and heated towel rail", type: "after" }
              ]
            },
            {
              id: "luxury-ensuite-gold-finish",
              title: "Luxury Ensuite Transformation – Gold Finish",
              hasBeforeAfter: true,
              coverImage: "/images/luxury-ensuite-gold/after-1.jpg",
              images: [
                { src: "/images/luxury-ensuite-gold/before-1.jpg", caption: "Original ensuite before renovation", type: "before" },
                { src: "/images/luxury-ensuite-gold/before-2.jpg", caption: "Existing bathroom layout and fixtures", type: "before" },
                { src: "/images/luxury-ensuite-gold/before-3.jpg", caption: "Previous shower and tiling area", type: "before" },
                { src: "/images/luxury-ensuite-gold/before-4.jpg", caption: "Original ensuite condition prior to refurbishment", type: "before" },
                { src: "/images/luxury-ensuite-gold/after-1.jpg", caption: "Complete ensuite with brushed gold shower enclosure, dark marble tiling and LED mirror", type: "after" },
                { src: "/images/luxury-ensuite-gold/after-2.jpg", caption: "Vanity area with backlit gold-framed mirror, wall-hung WC and dark marble tiles", type: "after" },
                { src: "/images/luxury-ensuite-gold/after-3.jpg", caption: "Brushed gold shower enclosure with rainfall head and dark marble feature wall", type: "after" },
                { src: "/images/luxury-ensuite-gold/after-4.jpg", caption: "Shower interior detail with gold drain, rainfall head and handheld shower", type: "after" },
                { src: "/images/luxury-ensuite-gold/after-5.jpg", caption: "Gold-framed LED mirror, wall-mounted basin, designer radiator and gold taps", type: "after" },
                { src: "/images/luxury-ensuite-gold/after-6.jpg", caption: "Gold-framed LED mirror, window surround with tiled reveal, basin and WC", type: "after" },
                { src: "/images/luxury-ensuite-gold/after-7.jpg", caption: "Full ensuite view with brushed gold shower enclosure and dark marble floor-to-ceiling tiling", type: "after" },
                { src: "/images/luxury-ensuite-gold/after-8.jpg", caption: "Doorway view showing gold shower enclosure, WC and dark marble tiling with carpet threshold", type: "after" },
                { src: "/images/luxury-ensuite-gold/after-9.jpg", caption: "Vanity area with backlit gold mirror, wall-mounted basin, designer radiator and WC", type: "after" },
                { src: "/images/luxury-ensuite-gold/after-10.jpg", caption: "Designer brushed gold heated radiator, LED mirror reflection and wall-mounted basin", type: "after" }
              ]
            },
            {
              id: "herringbone-bathroom-conversion",
              title: "Bathroom Conversion with Herringbone Style",
              hasBeforeAfter: true,
              coverImage: "/images/herringbone/after-2.jpg",
              images: [
                { src: "/images/herringbone/before-1.jpg", caption: "Original bathroom with dated bath and tiles", type: "before" },
                { src: "/images/herringbone/before-2.jpg", caption: "Original shower area and ceiling", type: "before" },
                { src: "/images/herringbone/before-3.jpg", caption: "Original basin and window area", type: "before" },
                { src: "/images/herringbone/after-1.jpg", caption: "Herringbone feature wall close-up with rainfall shower", type: "after" },
                { src: "/images/herringbone/after-2.jpg", caption: "Stunning herringbone feature wall with chrome fixtures", type: "after" },
                { src: "/images/herringbone/after-3.jpg", caption: "New window surround with herringbone tiling detail", type: "after" },
                { src: "/images/herringbone/after-4.jpg", caption: "New vanity unit with modern tiling", type: "after" },
                { src: "/images/herringbone/after-5.jpg", caption: "Complete shower area with herringbone wall and glass screen", type: "after" }
              ]
            },
            {
              id: "wet-room-refurbishment",
              title: "Complete Wet Room Refurbishment",
              hasBeforeAfter: true,
              coverImage: "/images/wetroom/after-1.jpg",
              images: [
                { src: "/images/wetroom/before-3.jpg", caption: "Original shower area", type: "before" },
                { src: "/images/wetroom/before-2.jpg", caption: "Original shower fixtures", type: "before" },
                { src: "/images/wetroom/before-1.jpg", caption: "Original corner basin", type: "before" },
                { src: "/images/wetroom/after-1.jpg", caption: "Complete wet room with patterned floor tiles", type: "after" },
                { src: "/images/wetroom/after-2.jpg", caption: "Modern rainfall shower and LED mirror", type: "after" },
                { src: "/images/wetroom/after-3.jpg", caption: "Vanity unit and feature flooring", type: "after" }
              ]
            },
            {
              id: "bathroom-redo-extending-shower",
              title: "Bathroom Redo, Extending Shower, Tiling and Vinyl Flooring",
              hasBeforeAfter: true,
              coverImage: "/images/bathroom-redo/after-1.jpg",
              images: [
                { src: "/images/bathroom-redo/before-1.jpg", caption: "Original bathroom with black floor tiles, pedestal basin and bath", type: "before" },
                { src: "/images/bathroom-redo/before-2.jpg", caption: "Original small shower cubicle with chrome frame enclosure", type: "before" },
                { src: "/images/bathroom-redo/before-3.jpg", caption: "Original shower area and tiled wall with recessed shelf", type: "before" },
                { src: "/images/bathroom-redo/after-1.jpg", caption: "Completed bathroom with sandstone wall tiling, new basin and vinyl flooring", type: "after" },
                { src: "/images/bathroom-redo/after-2.jpg", caption: "Extended shower enclosure with concrete-effect feature panels", type: "after" },
                { src: "/images/bathroom-redo/after-3.jpg", caption: "New shower area with full-height sandstone wall tiling", type: "after" },
                { src: "/images/bathroom-redo/after-4.jpg", caption: "Inside shower with concrete-effect panels and shower mixer", type: "after" },
                { src: "/images/bathroom-redo/after-5.jpg", caption: "Full room view with basin, WC, heated towel rail and vinyl flooring", type: "after" }
              ]
            },
            {
              id: "main-bathroom-refurbishment",
              title: "Main Bathroom Refurbishment",
              hasBeforeAfter: true,
              coverImage: "/images/main-bathroom/after-1.jpg",
              images: [
                { src: "/images/main-bathroom/before-1.jpg", caption: "Original bathroom with dated fixtures, blue walls and white panelling", type: "before" },
                { src: "/images/main-bathroom/before-2.jpg", caption: "Original bath and shower area with curtain and window", type: "before" },
                { src: "/images/main-bathroom/before-3.jpg", caption: "Full bathroom view through doorway showing bath, toilet and basin", type: "before" },
                { src: "/images/main-bathroom/after-1.jpg", caption: "Refurbished bathroom with new bath, WC, basin and mirror cabinet", type: "after" },
                { src: "/images/main-bathroom/after-2.jpg", caption: "Doorway view with herringbone vinyl floor and tiled bath surround", type: "after" },
                { src: "/images/main-bathroom/after-3.jpg", caption: "New mirror cabinet, pedestal basin and WC with herringbone floor", type: "after" },
                { src: "/images/main-bathroom/after-4.jpg", caption: "Bath area with grey tile surround, electric shower and glass screen", type: "after" },
                { src: "/images/main-bathroom/after-5.jpg", caption: "Bath surround tiling detail with window and clean finish", type: "after" }
              ]
            },
            {
              id: "cloakroom-bathroom-conversion",
              title: "Downstairs Cloakroom to Bathroom Conversion",
              coverImage: "/images/cloakroom/after-2.jpg",
              images: [
                { src: "/images/cloakroom/after-1.jpg", caption: "Vanity unit with sunburst mirror" },
                { src: "/images/cloakroom/after-2.jpg", caption: "Full bathroom with heated towel rail and modern WC" },
                { src: "/images/cloakroom/after-3.jpg", caption: "Wall-hung WC with concealed cistern" },
                { src: "/images/cloakroom/after-4.jpg", caption: "Vanity unit and sunburst mirror detail" }
              ]
            },
            {
              id: "cottage-bathroom-transformation",
              title: "Cottage Bathroom Transformation with Custom Niches",
              hasBeforeAfter: true,
              coverImage: "/images/cottage-bathroom/after-6.jpg",
              images: [
                { src: "/images/cottage-bathroom/before-1.jpg", caption: "Original cottage bathroom with dark feature tiles, WC and dated fixtures", type: "before" },
                { src: "/images/cottage-bathroom/before-2.jpg", caption: "Original vanity unit with shower over bath and tiled walls", type: "before" },
                { src: "/images/cottage-bathroom/before-3.jpg", caption: "Full bathroom view with bath, shower screen and WC", type: "before" },
                { src: "/images/cottage-bathroom/before-4.jpg", caption: "Original shower area with stone-effect tiling and window", type: "before" },
                { src: "/images/cottage-bathroom/after-6.jpg", caption: "Complete transformation with LED lighting, black vanity, walk-in shower and heated radiator", type: "after" },
                { src: "/images/cottage-bathroom/after-7.jpg", caption: "Full room view with horizontal radiator, wall-hung WC and LED mirror basin", type: "after" },
                { src: "/images/cottage-bathroom/after-8.jpg", caption: "Wall-hung WC with concealed cistern, custom niches and black radiator", type: "after" },
                { src: "/images/cottage-bathroom/after-9.jpg", caption: "Walk-in shower with black vanity unit, mirror reflection and WC", type: "after" },
                { src: "/images/cottage-bathroom/after-10.jpg", caption: "Custom dual recessed niches with mosaic tile backs and chrome trim", type: "after" },
                { src: "/images/cottage-bathroom/after-1.jpg", caption: "Bathroom view with grey stone tiling, black radiator and walk-in shower", type: "after" },
                { src: "/images/cottage-bathroom/after-2.jpg", caption: "Underfloor heating thermostat on grey marble-effect tiles", type: "after" },
                { src: "/images/cottage-bathroom/after-3.jpg", caption: "Matt black vertical radiator with thermostat and full bathroom view", type: "after" },
                { src: "/images/cottage-bathroom/after-4.jpg", caption: "LED backlit mirror with wall-mounted basin and chrome taps", type: "after" },
                { src: "/images/cottage-bathroom/after-5.jpg", caption: "Cottage doorway view with wooden door, toilet sign and full bathroom", type: "after" },
                { src: "/images/cottage-bathroom/after-11.jpg", caption: "Chrome handheld shower head on riser rail with spotlighting", type: "after" }
              ]
            }
          ]
        },
        {
          id: "mid-range-entry-level",
          title: "Mid-Range / Entry-Level Bathrooms",
          description: "Quality bathroom installations with excellent value and craftsmanship.",
          note: "For mid-range and entry-level bathrooms, we cover all types of tiling styles, repositioning and replacing toilets, sinks and shower mixers, bath to shower conversions, laying vinyl or floor tiling, PVC panel installation, and much more.",
          projects: [
            {
              id: "accessible-walk-in-shower-redo",
              title: "Accessible Walk-in Shower Re-do",
              hasBeforeAfter: true,
              coverImage: "/images/walk-in-shower/after-2.jpg",
              images: [
                { src: "/images/walk-in-shower/before-1.jpg", caption: "Original shower enclosure with dated tiles and fittings", type: "before" },
                { src: "/images/walk-in-shower/before-2.jpg", caption: "Original bathroom with quadrant shower and pedestal basin", type: "before" },
                { src: "/images/walk-in-shower/after-1.jpg", caption: "New shower enclosure with modern grey wall panels", type: "after" },
                { src: "/images/walk-in-shower/after-2.jpg", caption: "Completed bathroom with updated shower, basin and mirror", type: "after" },
                { src: "/images/walk-in-shower/after-3.jpg", caption: "Accessible walk-in shower with fold-down seat and new fixtures", type: "after" }
              ]
            },
            {
              id: "ensuite-leak-repair-panel",
              title: "En Suite Bathroom Leak Repair and Panel Installation",
              hasBeforeAfter: true,
              coverImage: "/images/ensuite-leak/after-1.jpg",
              images: [
                { src: "/images/ensuite-leak/before-1.jpg", caption: "Original en suite shower with exposed pipework and dated tiles", type: "before" },
                { src: "/images/ensuite-leak/after-1.jpg", caption: "New shower enclosure with sleek grey panels", type: "after" },
                { src: "/images/ensuite-leak/after-2.jpg", caption: "Close-up of new wall panels and thermostatic shower bar", type: "after" },
                { src: "/images/ensuite-leak/after-3.jpg", caption: "New shower tray and panel finish detail", type: "after" }
              ]
            },
            {
              id: "pvc-panels-shower-mixer",
              title: "Installation of PVC Shower Panels and Shower Mixer Upgrade",
              hasBeforeAfter: true,
              coverImage: "/images/pvc-panels/after-1.jpg",
              images: [
                { src: "/images/pvc-panels/before-1.jpg", caption: "Original bathroom with dated blue floral tiles and old fixtures", type: "before" },
                { src: "/images/pvc-panels/after-1.jpg", caption: "New marble-effect PVC panels with upgraded thermostatic shower mixer", type: "after" },
                { src: "/images/pvc-panels/after-2.jpg", caption: "PVC panel corner detail with marble-effect finish and shelf", type: "after" },
                { src: "/images/pvc-panels/after-3.jpg", caption: "Full wall panel coverage with new shower riser", type: "after" },
                { src: "/images/pvc-panels/after-4.jpg", caption: "New thermostatic mixer valve with old bath taps awaiting replacement", type: "after" }
              ]
            },
            {
              id: "ensuite-refurbishment",
              title: "Ensuite Refurbishment",
              hasBeforeAfter: true,
              coverImage: "/images/ensuite/after-3.jpg",
              images: [
                { src: "/images/ensuite/before-1.jpg", caption: "Original ensuite with dated decor", type: "before" },
                { src: "/images/ensuite/before-2.jpg", caption: "Original shower area with worn tiles", type: "before" },
                { src: "/images/ensuite/before-3.jpg", caption: "Original toilet with exposed copper pipes", type: "before" },
                { src: "/images/ensuite/after-1.jpg", caption: "Modern rainfall shower with mosaic shelf", type: "after" },
                { src: "/images/ensuite/after-2.jpg", caption: "Thermostatic shower bar with fold-down seat", type: "after" },
                { src: "/images/ensuite/after-3.jpg", caption: "LED mirror cabinet with floating basin", type: "after" }
              ]
            },
            {
              id: "shower-wall-tile-installation",
              title: "Shower Wall Tile Installation",
              coverImage: "/images/shower-wall-tiles/image-1.jpg",
              images: [
                { src: "/images/shower-wall-tiles/image-1.jpg", caption: "Completed shower wall tiling with modern grey tiles" }
              ]
            },
            {
              id: "bathroom-shower-installation-refurb",
              title: "Bathroom Shower Installation and Refurbishment",
              hasBeforeAfter: true,
              coverImage: "/images/bathroom-shower-install/after-1.jpg",
              images: [
                { src: "/images/bathroom-shower-install/before-1.jpg", caption: "Original bathroom with carpeted floor and dated fixtures", type: "before" },
                { src: "/images/bathroom-shower-install/before-2.jpg", caption: "Original bath area with electric shower and worn tiling", type: "before" },
                { src: "/images/bathroom-shower-install/after-1.jpg", caption: "Completed bathroom with corner shower enclosure, dark feature tiles and pedestal basin", type: "after" },
                { src: "/images/bathroom-shower-install/after-2.jpg", caption: "Refurbished bathroom with new floor tiles and heated towel rail", type: "after" },
                { src: "/images/bathroom-shower-install/after-3.jpg", caption: "New shower enclosure with dark feature tiles and chrome fittings", type: "after" },
                { src: "/images/bathroom-shower-install/after-4.jpg", caption: "New pedestal basin and bath with full wall tiling", type: "after" }
              ]
            },
            {
              id: "bath-to-shower-conversion",
              title: "Bath to Shower Conversion",
              hasBeforeAfter: true,
              coverImage: "/images/bath-to-shower/after-3.jpg",
              images: [
                { src: "/images/bath-to-shower/before-1.jpg", caption: "Original bathroom with old bath, laminate flooring and dated tiles", type: "before" },
                { src: "/images/bath-to-shower/before-2.jpg", caption: "Original bath area with dated taps and worn tiling", type: "before" },
                { src: "/images/bath-to-shower/after-1.jpg", caption: "New bath with glass shower screen and white wall tiling", type: "after" },
                { src: "/images/bath-to-shower/after-2.jpg", caption: "New pedestal basin, WC and oval mirror with decorative border", type: "after" },
                { src: "/images/bath-to-shower/after-3.jpg", caption: "Complete bathroom with new bath, glass screen, radiator and vinyl flooring", type: "after" }
              ]
            },
            {
              id: "full-large-bathroom-refurbishment",
              title: "Full Large Bathroom Refurbishment",
              hasBeforeAfter: true,
              coverImage: "/images/full-large/after-3.jpg",
              images: [
                { src: "/images/full-large/before-1.jpg", caption: "Original large bathroom with dated fixtures", type: "before" },
                { src: "/images/full-large/before-2.jpg", caption: "Original bath area with worn tiling", type: "before" },
                { src: "/images/full-large/before-3.jpg", caption: "Original WC area with exposed pipework", type: "before" },
                { src: "/images/full-large/after-1.jpg", caption: "New WC area with modern floor tiles and bidet spray", type: "after" },
                { src: "/images/full-large/after-2.jpg", caption: "Bespoke mosaic corner shelves", type: "after" },
                { src: "/images/full-large/after-3.jpg", caption: "Large walk-in shower enclosure with blue feature tiles", type: "after" },
                { src: "/images/full-large/after-4.jpg", caption: "Chrome bidet spray with modern fixtures", type: "after" },
                { src: "/images/full-large/after-5.jpg", caption: "Concealed thermostatic shower valve", type: "after" }
              ]
            },
            {
              id: "shower-area-redo",
              title: "Shower Area Redo",
              hasBeforeAfter: true,
              coverImage: "/images/shower-area-redo/after-1.jpg",
              images: [
                { src: "/images/shower-area-redo/before-1.jpg", caption: "Old shower tray drain showing wear and discolouration", type: "before" },
                { src: "/images/shower-area-redo/before-2.jpg", caption: "Existing quadrant shower enclosure with sliding doors", type: "before" },
                { src: "/images/shower-area-redo/before-3.jpg", caption: "Shower valve controls with worn tile surround", type: "before" },
                { src: "/images/shower-area-redo/before-4.jpg", caption: "Shower door and handle detail showing age and limescale", type: "before" },
                { src: "/images/shower-area-redo/before-5.jpg", caption: "Full view of existing shower enclosure before redo", type: "before" },
                { src: "/images/shower-area-redo/after-1.jpg", caption: "Completed shower area with new marble-effect panels and quadrant enclosure", type: "after" },
                { src: "/images/shower-area-redo/after-2.jpg", caption: "New quadrant shower with marble-effect PVC wall panels", type: "after" },
                { src: "/images/shower-area-redo/after-3.jpg", caption: "New shower tray and enclosure base detail with clean seal", type: "after" },
                { src: "/images/shower-area-redo/after-4.jpg", caption: "Chrome rainfall showerhead and riser rail against marble panels", type: "after" },
                { src: "/images/shower-area-redo/after-5.jpg", caption: "Close-up of new dual showerhead and riser rail fittings", type: "after" }
              ]
            }
          ]
        },
        {
          id: "flooring",
          title: "Flooring",
          description: "Professional floor tiling installations for kitchens, bathrooms, living rooms and hallways.",
          projects: [
            {
              id: "kitchen-floor-tiling",
              title: "Kitchen Floor Tiling",
              coverImage: "/images/kitchen-floor-tiling/image-1.jpg",
              images: [
                { src: "/images/kitchen-floor-tiling/image-1.jpg", caption: "Kitchen marble-effect floor tiling with radiator and worktop" },
                { src: "/images/kitchen-floor-tiling/image-2.jpg", caption: "Wide view of kitchen floor with marble-effect tiles and back door" },
                { src: "/images/kitchen-floor-tiling/image-3.jpg", caption: "Under-worktop tiling detail with timber frame and boiler" },
                { src: "/images/kitchen-floor-tiling/image-4.jpg", caption: "Kitchen doorway view with marble-effect floor meeting hallway" },
                { src: "/images/kitchen-floor-tiling/image-5.jpg", caption: "Full kitchen floor tiling with marble-effect porcelain tiles" }
              ]
            },
            {
              id: "bathroom-mosaic-floor-tiling-shower",
              title: "Bathroom Mosaic Floor Tiling and Shower",
              coverImage: "/images/bathroom-mosaic-floor/after-1.jpg",
              images: [
                { src: "/images/bathroom-mosaic-floor/after-1.jpg", caption: "Full bathroom view with patterned mosaic floor tiles and black shower screen" },
                { src: "/images/bathroom-mosaic-floor/after-2.jpg", caption: "Mosaic floor tile pattern close-up detail" },
                { src: "/images/bathroom-mosaic-floor/after-3.jpg", caption: "Mosaic floor tiling around wall-hung WC" },
                { src: "/images/bathroom-mosaic-floor/after-4.jpg", caption: "Precision tile cutting around pedestal pipe" },
                { src: "/images/bathroom-mosaic-floor/after-5.jpg", caption: "Matt black thermostatic shower mixer with riser rail" }
              ]
            },
            {
              id: "living-room-hallway-floor-tiling",
              title: "Living Room and Hallway Floor Tiling",
              coverImage: "/images/living-hallway-floor/after-1.jpg",
              images: [
                { src: "/images/living-hallway-floor/after-1.jpg", caption: "Large format polished porcelain floor tiles in hallway" },
                { src: "/images/living-hallway-floor/after-2.jpg", caption: "Bathroom floor tiling with large format tiles" },
                { src: "/images/living-hallway-floor/after-3.jpg", caption: "Floor tiling up to front door threshold" },
                { src: "/images/living-hallway-floor/after-4.jpg", caption: "Continuous floor tiling through hallway and doorways" },
                { src: "/images/living-hallway-floor/after-5.jpg", caption: "Polished porcelain floor tiles in living room with radiator" }
              ]
            },
            {
              id: "mosaic-hallway-tiling",
              title: "Mosaic Hallway Tiling",
              coverImage: "/images/mosaic-hallway/image-1.jpg",
              images: [
                { src: "/images/mosaic-hallway/image-1.jpg", caption: "Geometric mosaic hallway tiles with radiator cover and skirting" },
                { src: "/images/mosaic-hallway/image-2.jpg", caption: "Mosaic pattern detail with radiator cover and dark accent wall" },
                { src: "/images/mosaic-hallway/image-3.jpg", caption: "Floor-level view of geometric mosaic tiling towards hallway" },
                { src: "/images/mosaic-hallway/image-4.jpg", caption: "Overhead view of completed mosaic hallway floor pattern" },
                { src: "/images/mosaic-hallway/image-5.jpg", caption: "Hallway corner with mosaic tiles meeting staircase and panelling" }
              ]
            }
          ]
        },
        {
          id: "rental-property-renovations",
          title: "Bathroom Renovation Projects for Rental Properties",
          description: "Targeted at property investors and landlords.",
          projects: [
            {
              id: "bathroom-redo-rental",
              title: "Bathroom Redo",
              coverImage: "/images/bathroom-redo-rental/after-1.jpg",
              images: [
                { src: "/images/bathroom-redo-rental/after-1.jpg", caption: "Completed rental bathroom with bath, shower screen and new fixtures" }
              ]
            },
            {
              id: "downstairs-bathroom-refurbished",
              title: "Downstairs Bathroom Refurbished",
              coverImage: "/images/downstairs-bathroom-refurbished/after-1.jpg",
              images: [
                { src: "/images/downstairs-bathroom-refurbished/after-1.jpg", caption: "Refurbished downstairs bathroom with new bath, shower screen and tiling" }
              ]
            },
            {
              id: "downstairs-bathroom-tiled-lighting",
              title: "Downstairs Bathroom Tiled + New Lighting",
              coverImage: "/images/downstairs-bathroom-tiled/after-1.jpg",
              images: [
                { src: "/images/downstairs-bathroom-tiled/after-1.jpg", caption: "Fully tiled downstairs bathroom with mosaic border and new spotlights" }
              ]
            },
            {
              id: "shower-installation-rental",
              title: "Shower Installation",
              coverImage: "/images/shower-installation-rental/after-1.jpg",
              images: [
                { src: "/images/shower-installation-rental/after-1.jpg", caption: "New shower enclosure with dark feature tiles and thermostatic mixer" },
                { src: "/images/shower-installation-rental/after-2.jpg", caption: "Full bathroom view with shower enclosure, basin and window" }
              ]
            },
            {
              id: "upstairs-bathroom-refurb-extractor",
              title: "Upstairs Bathroom Refurbishment (Extractor Fan + Everything Redone)",
              coverImage: "/images/upstairs-bathroom-refurb/after-1.jpg",
              images: [
                { src: "/images/upstairs-bathroom-refurb/after-1.jpg", caption: "Refurbished bathroom with new extractor fan, grey tiling and mosaic floor" },
                { src: "/images/upstairs-bathroom-refurb/after-2.jpg", caption: "New basin, heated towel rail and feature mirror" }
              ]
            }
          ]
        }
      ]
    },
    refurbishment: {
      title: "Refurbishment",
      subsections: [
        {
          id: "kitchen-installations",
          title: "Kitchen Installations",
          description: "High-quality kitchen fitting and finishing.",
          projects: [
            {
              id: "full-kitchen-installation-floor-tiling",
              title: "Full Kitchen Installation + Floor Tiling",
              coverImage: "/images/full-kitchen-install/image-1.jpg",
              images: [
                { src: "/images/full-kitchen-install/image-1.jpg", caption: "Range cooker with tiled arch feature and new floor tiles" },
                { src: "/images/full-kitchen-install/image-2.jpg", caption: "Walnut units with dark worktop and metro tile cooker surround" },
                { src: "/images/full-kitchen-install/image-3.jpg", caption: "Full kitchen view with walnut cabinetry and polished floor tiles" },
                { src: "/images/full-kitchen-install/image-4.jpg", caption: "Sink area with dark worktop and new floor tiling throughout" }
              ]
            },
            {
              id: "new-kitchen-floor-tiling",
              title: "Installation of New Kitchen and Floor Tiling",
              coverImage: "/images/new-kitchen-floor/image-1.jpg",
              images: [
                { src: "/images/new-kitchen-floor/image-1.jpg", caption: "Open-plan kitchen with oak units, metro tile splashback and large format floor tiles" },
                { src: "/images/new-kitchen-floor/image-2.jpg", caption: "Gas hob with chimney hood, wine rack and metro tile detail" }
              ]
            },
            {
              id: "new-installation-kitchen",
              title: "New Installation of Kitchen",
              coverImage: "/images/new-installation-kitchen/image-1.jpg",
              images: [
                { src: "/images/new-installation-kitchen/image-1.jpg", caption: "Galley kitchen with oak units, metro tile splashback and dark floor tiles" },
                { src: "/images/new-installation-kitchen/image-2.jpg", caption: "Full kitchen view from doorway with fitted units both sides" }
              ]
            },
            {
              id: "kitchen-refresh-cabinets-tiling-flooring",
              title: "Kitchen Refresh, New Cabinets, New Tiling + New Flooring",
              hasBeforeAfter: true,
              coverImage: "/images/kitchen-refresh/after-4.jpg",
              images: [
                { src: "/images/kitchen-refresh/before-1.jpg", caption: "Original kitchen corridor with worn carpet and dated skirting", type: "before" },
                { src: "/images/kitchen-refresh/before-2.jpg", caption: "Galley kitchen view through archway showing damaged laminate flooring", type: "before" },
                { src: "/images/kitchen-refresh/before-3.jpg", caption: "Old kitchen with washing machine, worn floor tiles and dated cabinets", type: "before" },
                { src: "/images/kitchen-refresh/after-1.jpg", caption: "New white cabinets with oak worktop, metro tiles and vinyl wood flooring", type: "after" },
                { src: "/images/kitchen-refresh/after-2.jpg", caption: "Full kitchen view with new cabinets, tiling and flooring throughout", type: "after" },
                { src: "/images/kitchen-refresh/after-3.jpg", caption: "Utility area with new worktop, metro tile splashback and washing machine", type: "after" },
                { src: "/images/kitchen-refresh/after-4.jpg", caption: "Cooker area with new cabinets, extractor hood and metro tile splashback", type: "after" },
                { src: "/images/kitchen-refresh/after-5.jpg", caption: "Window area with metro tiling around boiler and new oak worktop", type: "after" }
              ]
            },
            {
              id: "full-kitchen-refurb-floor-tiles",
              title: "Full Kitchen Refurbishment + New Floor Tiles",
              coverImage: "/images/full-kitchen-refurb/image-1.jpg",
              images: [
                { src: "/images/full-kitchen-refurb/image-1.jpg", caption: "Refurbished kitchen with oak cabinets, dark worktop, extractor hood and new grey floor tiles" },
                { src: "/images/full-kitchen-refurb/image-2.jpg", caption: "Floor tile detail with neat cut around oak cabinet base" },
                { src: "/images/full-kitchen-refurb/image-3.jpg", caption: "Corner view with large format grey floor tiles and oak cabinets" }
              ]
            },
            {
              id: "kitchen-refurb-splashback-wall-repair",
              title: "Kitchen Refurbishment, New Splash Back Tiles and Wall Repaired",
              hasBeforeAfter: true,
              coverImage: "/images/kitchen-splashback-wall/after-1.jpg",
              images: [
                { src: "https://customer-assets.emergentagent.com/job_3e849b0a-3eb9-4a57-9473-38116027ffed/artifacts/u87kef9l_20260529_121244.jpg", caption: "Original kitchen with dated decorative splashback tiles and pine cabinets", type: "before" },
                { src: "https://customer-assets.emergentagent.com/job_3e849b0a-3eb9-4a57-9473-38116027ffed/artifacts/jidbvr40_20260529_121246.jpg", caption: "Damaged and cracked wall above old tiles with exposed boiler area", type: "before" },
                { src: "https://customer-assets.emergentagent.com/job_3e849b0a-3eb9-4a57-9473-38116027ffed/artifacts/u3h2px49_20260529_121250.jpg", caption: "Original sink area with old decorative tiles, washing machine and boiler", type: "before" },
                { src: "/images/kitchen-splashback-wall/after-1.jpg", caption: "U-shaped kitchen with wood cabinets, gas hob and new subway tile splashback", type: "after" },
                { src: "/images/kitchen-splashback-wall/after-2.jpg", caption: "Sink area with repaired wall, new subway tiles and boiler", type: "after" },
                { src: "/images/kitchen-splashback-wall/after-3.jpg", caption: "L-shaped kitchen with pine cabinets and full subway tile splashback", type: "after" },
                { src: "/images/kitchen-splashback-wall/after-4.jpg", caption: "Close-up corner detail of white subway tiles with dark grout", type: "after" },
                { src: "/images/kitchen-splashback-wall/after-5.jpg", caption: "Window surround tiling detail with subway tiles on sill and wall", type: "after" }
              ]
            },
            {
              id: "kitchen-refurb-splashback-cabinets",
              title: "Full Kitchen Refurbishment, Including Splash-back Tiling + Re-arrangement of Cabinets",
              coverImage: "/images/kitchen-splashback/image-1.jpg",
              images: [
                { src: "/images/kitchen-splashback/image-1.jpg", caption: "Refurbished galley kitchen with cream cabinets, granite-effect worktop and metro tile splashback" },
                { src: "/images/kitchen-splashback/image-2.jpg", caption: "Cooking area with ceramic hob, chimney hood and metro tiling" },
                { src: "/images/kitchen-splashback/image-3.jpg", caption: "Full kitchen view with rearranged cabinets and wine rack" },
                { src: "/images/kitchen-splashback/image-4.jpg", caption: "Corner hob detail with full metro tile splashback" }
              ]
            }
          ]
        },
        {
          id: "cinema-transformations",
          title: "Cinema-Style Transformations",
          description: "Custom featured walls, full cinema sound systems, custom projector installation, and custom screen customisation.",
          projects: [
            {
              id: "conservatory-conversion-media-wall",
              title: "Conservatory Conversion to Media Wall",
              hasBeforeAfter: true,
              coverImage: "/images/conservatory-media-wall/after-2.jpg",
              images: [
                { src: "/images/conservatory-media-wall/before-1.jpg", caption: "Original conservatory interior with bare walls and floor protection", type: "before" },
                { src: "/images/conservatory-media-wall/before-2.jpg", caption: "Conservatory exterior view before conversion", type: "before" },
                { src: "/images/conservatory-media-wall/after-1.jpg", caption: "Completed media wall with mounted TV, electric fireplace and lit display niches", type: "after" },
                { src: "/images/conservatory-media-wall/after-2.jpg", caption: "Custom lit display niches with downlights", type: "after" },
                { src: "/images/conservatory-media-wall/after-3.jpg", caption: "Display niches and TV detail with ambient lighting", type: "after" },
                { src: "/images/conservatory-media-wall/after-4.jpg", caption: "Recessed electric fireplace with flame effect detail", type: "after" },
                { src: "/images/conservatory-media-wall/after-5.jpg", caption: "Media wall with colour-changing LED backlighting and display niches", type: "after" },
                { src: "/images/conservatory-media-wall/after-6.jpg", caption: "Completed brick extension exterior with new roofline", type: "after" },
                { src: "/images/conservatory-media-wall/after-7.jpg", caption: "Exterior view showing media wall visible through window", type: "after" }
              ]
            }
          ]
        },
        {
          id: "garden-conversions",
          title: "Garden Conversions",
          description: "Transforming outdoor spaces into functional living areas.",
          projects: [
            {
              id: "complete-garden-transformation",
              title: "Complete Garden Transformation",
              hasBeforeAfter: true,
              coverImage: "/images/garden-transformation/after-2.jpg",
              images: [
                { src: "/images/garden-transformation/before-1.jpg", caption: "Original garden with mossy, worn-out decking and clutter", type: "before" },
                { src: "/images/garden-transformation/before-2.jpg", caption: "Cluttered back yard with faded red fencing, wheelbarrow and tools", type: "before" },
                { src: "/images/garden-transformation/before-3.jpg", caption: "Wide view of neglected garden with old red fences and overgrown paving", type: "before" },
                { src: "/images/garden-transformation/after-1.jpg", caption: "Luxury outdoor lounge area with L-shaped sofa, cedar fencing and ambient lighting", type: "after" },
                { src: "/images/garden-transformation/after-2.jpg", caption: "New stone paving with cedar slat fencing, warm wall lights and planters", type: "after" },
                { src: "/images/garden-transformation/after-3.jpg", caption: "Cedar slat fence corner with warm down-lights, box planters and stone paving", type: "after" }
              ]
            },
            {
              id: "fence-repair-shed-construction",
              title: "Fence Repair and Full Shed Construction",
              coverImage: "/images/shed-construction/image-1.jpg",
              images: [
                { src: "/images/shed-construction/image-1.jpg", caption: "Side view of completed shed with new fence panel and guttering" },
                { src: "/images/shed-construction/image-2.jpg", caption: "Interior of shed with timber frame, wiring and OSB lining" },
                { src: "/images/shed-construction/image-3.jpg", caption: "Front view of completed shed with double doors and apex roof" }
              ]
            }
          ]
        },
        {
          id: "other-refurbishment",
          title: "Other",
          description: "Additional refurbishment and renovation projects.",
          projects: [
            {
              id: "construction-electrical-cabinet",
              title: "Construction of Electrical Cabinet",
              hasBeforeAfter: true,
              coverImage: "/images/electrical-cabinet/after-2.jpg",
              images: [
                { src: "/images/electrical-cabinet/before-1.jpg", caption: "Living room with exposed electrical board and meters next to fireplace", type: "before" },
                { src: "/images/electrical-cabinet/before-2.jpg", caption: "Close-up of exposed electrical meters, consumer unit and wiring", type: "before" },
                { src: "/images/electrical-cabinet/after-2.jpg", caption: "Custom-built white cabinet with chrome handles concealing all electrics", type: "after" },
                { src: "/images/electrical-cabinet/after-1.jpg", caption: "Cabinet doors open showing meters and consumer unit neatly housed inside", type: "after" }
              ]
            },
            {
              id: "construction-boiler-cabinet",
              title: "Construction of Boiler Cabinet",
              coverImage: "/images/boiler-cabinet/image-1.jpg",
              images: [
                { src: "/images/boiler-cabinet/image-1.jpg", caption: "Custom-built full-height boiler cabinet with double doors and venetian blind above" },
                { src: "/images/boiler-cabinet/image-2.jpg", caption: "Cabinet open showing boiler, pipework and timber frame inside" }
              ]
            },
            {
              id: "ring-doorbell-installation",
              title: "Installation of a Ring Doorbell",
              coverImage: "/images/ring-doorbell/image-2.jpg",
              images: [
                { src: "/images/ring-doorbell/image-1.jpg", caption: "Ring doorbell installed next to existing intercom on door frame" },
                { src: "/images/ring-doorbell/image-2.jpg", caption: "Ring video doorbell mounted on brick wall beside front door" },
                { src: "/images/ring-doorbell/image-3.jpg", caption: "Neat cable trunking routing power to doorbell" }
              ]
            },
            {
              id: "bathroom-damp-remediation",
              title: "Bathroom Damp Remediation",
              hasBeforeAfter: true,
              coverImage: "/images/bathroom-damp-remediation/after-1.jpg",
              images: [
                { src: "/images/bathroom-damp-remediation/before-1.jpg", caption: "Severe mould and damp on bathroom ceiling before remediation", type: "before" },
                { src: "/images/bathroom-damp-remediation/after-1.jpg", caption: "Clean ceiling with new light fitting after damp remediation", type: "after" }
              ]
            }
          ]
        }
      ]
    }
  };
